import { render, staticRenderFns } from "./FollowUpSummary.vue?vue&type=template&id=50719846&scoped=true&"
import script from "./FollowUpSummary.vue?vue&type=script&lang=ts&"
export * from "./FollowUpSummary.vue?vue&type=script&lang=ts&"
import style0 from "./FollowUpSummary.vue?vue&type=style&index=0&id=50719846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50719846",
  null
  
)

/* custom blocks */
import block0 from "./FollowUpSummary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports